import React, { Component } from 'react';
import styled from 'styled-components';
import { Overlay, Modal } from 'react-overlays';

import Close from './images/close.png';

const StyledModalContent = styled.div`
  position: relative;
  width: auto;
  height: auto;
  max-height: 100vh;
	background: rgba(255,255,255,0.85);
  box-shadow: 0 10px 20px rgba(91, 107, 174, .1);

  img {
    max-width: 100%;
  }

  .close-modal {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 18px;
    height: 18px;
  }

`;

class ModalView extends Component {
  render() {
    let left = this.props.left ? this.props.left : 0;
    const modalStyle = {
      position: 'fixed',
      zIndex: 9999,
      top: 0, bottom: 0, left: 0, right: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

    const backdropStyle = {
      ...modalStyle,
      zIndex: 'auto',
      backgroundColor: '#000',
      opacity: 0
    };
    return (
      <Modal
        aria-labelledby='modal-label'
        style={modalStyle}
        backdropStyle={backdropStyle}
        show={this.props.visible}
        onHide={this.props.handleClose}
        containerClassName={'modal'}
      >

          <StyledModalContent style={{transform: `translate(${window.innerWidth < 1025 && left < 0 ? (left + 10) : (left -10)}%, 0%) scale(${window.innerWidth < 1025 ? '0.8' : '1'})`, width: this.props.maxWidth*0.7,maxWidth: '70vw', padding: this.props.noPadding ? '0px' : '15px' }}>
            <img src={Close} onClick={() => this.props.handleClose()} className="close-modal" />
            {console.log(window.innerWidth)}
            {this.props.children}
          </StyledModalContent>
      </Modal>
    );
  }
}

export default ModalView;



// WEBPACK FOOTER //
// ./src/Modal.js